import {
    animate,
    animateChild,
    group,
    query,
    stagger,
    style,
    transition,
    trigger
} from '@angular/animations';

export const list = [
    trigger('list', [
        transition('* <=> *', [
            query('@*', stagger('50ms', [animateChild()]), { optional: true })
        ])
    ])
];

export const slideInOut = [
    trigger('slideInOut', [
        transition(':enter', [
            style({ opacity: 0, transform: 'translate3d(-5%,0, 0)' }),
            animate(
                '250ms ease-out',
                style({ opacity: 1, transform: 'translate3d(0,0, 0)' })
            )
        ]),
        transition(':leave', [
            style({ opacity: 1, transform: 'translate3d(0,0, 0)' }),
            animate(
                '150ms ease-in',
                style({ opacity: 0, transform: 'translate3d(10%,0, 0)' })
            )
        ])
    ])
];

export const fadeInOut = [
    trigger('fadeInOut', [
        transition(':enter', [
            style({ opacity: 0 }),
            animate('300ms ease-out', style({ opacity: 1 }))
        ]),
        transition(':leave', [
            style({ opacity: 1 }),
            animate('300ms ease-in', style({ opacity: 0 }))
        ])
    ])
];

export const fadeInOutModal = [
    trigger('fadeInOutModal', [
        transition(':enter', [
            group([
                query(
                    '.backdrop',
                    [
                        style({ opacity: 0 }),
                        animate('300ms ease-out', style({ opacity: 1 }))
                    ],
                    { optional: true }
                ),
                query(
                    '.sb-modal-grid:not(.sb-modal-aside-right) .sb-modal-grid-container',
                    [
                        style({ opacity: 0, transform: 'translate3d(0,100%,0)' }),
                        animate(
                            '800ms 300ms cubic-bezier(0, 1, 0.5, 1)',
                            style({ opacity: 1, transform: 'translate3d(0,0,0)' })
                        )
                    ],
                    { optional: true }
                ),
                query(
                    '.sb-modal-aside-right .sb-modal-grid-container',
                    [
                        style({ opacity: 0, transform: 'translate3d(100%,0,0)' }),
                        animate(
                            '800ms 300ms cubic-bezier(0, 1, 0.5, 1)',
                            style({ opacity: 1, transform: 'translate3d(0,0,0)' })
                        )
                    ],
                    { optional: true }
                )
            ])
        ]),
        transition(':leave', [
            group([
                query(
                    '.backdrop',
                    [
                        style({ opacity: 1 }),
                        animate('300ms 300ms ease-in', style({ opacity: 0 }))
                    ],
                    { optional: true }
                ),
                query(
                    '.sb-modal-grid:not(.sb-modal-aside-right) .sb-modal-grid-container',
                    [
                        style({ opacity: 1, transform: 'translate3d(0,0,0)' }),
                        animate(
                            '300ms ease-in',
                            style({ opacity: 0, transform: 'translate3d(0,100%,0)' })
                        )
                    ],
                    { optional: true }
                ),
                query(
                    '.sb-modal-grid.sb-modal-aside-right .sb-modal-grid-container',
                    [
                        style({ opacity: 1, transform: 'translate3d(0,0,0)' }),
                        animate(
                            '300ms ease-in',
                            style({ opacity: 0, transform: 'translate3d(100%,0,0)' })
                        )
                    ],
                    { optional: true }
                )
            ])
        ])
    ])
];
